<div class="container">
    <h2>
        Email delivery report
    </h2>

    <form [formGroup]="form" class="inputs">
        <div class="date-field">
            <label>Date From</label>
            <owc-datepicker 
                size="medium" 
                format ="dd-MMM-yyyy" 
                variant="outlined" 
                placeholder="DD/MM/YYYY"
                formControlName="dateFrom">
            </owc-datepicker>
        </div>

        <div class="date-field">
            <label>Date To</label>
            <owc-datepicker 
                size="medium" 
                format ="dd-MMM-yyyy"
                variant="outlined" 
                placeholder="DD/MM/YYYY"
                formControlName="dateTo">
            </owc-datepicker>
        </div>

        <div class="input-field" style="margin-top: 25px;">
            <owc-input 
                label="Notification" 
                variant="outlined"
                placeholder="Enter Notification"
                formControlName="notification">
            </owc-input>
        </div>

        <div class="input-field" style="margin-top: 25px;">
            <owc-input 
                label="Account" 
                variant="outlined"
                placeholder="Enter account"
                formControlName="account">
            </owc-input>
        </div>

        <div class="select-field">
            <label>Country</label>
            <owc-select-dropdown 
                formControlName="country" 
                variant="outlined"
                multiple
                (visibleChange)="onCountryChange()">
                <owc-list-item *ngFor="let country of countries" [value]="country" [disabled]="isCountryDisabled(country)">
                    {{ country }}
                </owc-list-item>
            </owc-select-dropdown>
        </div>

        <div class="select-field">
            <label>Delivery Status</label>
            <owc-select-dropdown 
                formControlName="deliveryStatus" 
                [placeholder]="selectedRolesDisplay('deliveryStatus')"
                variant="outlined"
                multiple
                (selectionChange)="onStatusChange()">
                <owc-list-item *ngFor="let status of deliveryStatuses" [value]="status" [disabled]="isStatusDisabled(status)">
                    {{ status }}
                </owc-list-item>
            </owc-select-dropdown>
        </div>

        <div class="error-message" *ngIf="form.hasError('dateRangeInvalid') && (form.get('dateFrom')?.touched || form.get('dateTo')?.touched)">
            'Date From' must be before or equal to 'Date To'
        </div>

    </form>

    <section class="buttons">
        <owc-button color="primary" [disabled]="form.invalid" (click)="search()">
            Search
        </owc-button>

        <owc-button color="primary" [disabled]="form.invalid" (click)="onDownload()">
            Download
        </owc-button>
    </section>

    <owc-modal-dialog size="small" [(ngModel)]="downloadVisible">
        <dl-file-format-dialog (formatSelected)="onFormatSelected($event)"></dl-file-format-dialog>
      </owc-modal-dialog>

    <section class="progress-container">
        <div class="progress-label">
            <div>{{deliveredPercent}}%</div>
            <div>{{failedPercent}}%</div>
        </div>

        <div class="progress-bar">
            <div class="delivered" #delivered [title]="deliveredTitle"></div>
            <div class="failed" #failed [title]="failedTitle"></div>
        </div>

        <div class="legend">
            <div class="legend-item">
                <span class="legend-color delivered-color"></span>
                Delivered
            </div>
            <div class="legend-item">
                <span class="legend-color failed-color"></span>
                Failed
            </div>
        </div>
    </section>

    <section>
        <dl-email-delivery-table [emailTableData]="emailTableData"></dl-email-delivery-table>
    </section>
</div>